import InvStratDiversificationConsiderationDialog from '@/app/modules/toolkit/inv-strat/components/inv-strat-diversification-consideration-dialog/inv-strat-diversification-consideration-dialog.vue';

export default {
  name: 'inv-strat-diversification-consideration',
  components: {
    InvStratDiversificationConsiderationDialog,
  },
  props: {
    asset: {
      type: Object,
      required: true,
    },
    considerations: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    showConsiderationDialog: false,
  }),

  methods: {
    handleConsiderationClick() {
      this.showConsiderationDialog = true;
    },
    handleConsiderationSelections(event) {
      this.$emit('considerationSelections', event);
    },

  },
};
